import { lazyLoad } from 'utils/loadable';

export const LabelPrintDialog = lazyLoad(
  () => import('./index'),
  module => module.LabelPrintDialog,
);
